import client from '@/api/client';
import { gql } from '@apollo/client';

const getLessonHistory = (studentId?: number) => client
  .query({
    query: gql`
    query(
      $studentId: Int
    ) {
      getLessonHistory(studentId: $studentId) {
        teacher: reporterName
        date: createdAt
        status: balance
      }
    }
  `,
    variables: {
      studentId,
    },
  });

export default { getLessonHistory };
